<div class="d-flex justify-content-between align-items-center">
  <div class="card-sub-heading bold pay_with_title">Pay with other</div>
  <button mat-icon-button (click)="dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>

  <div class="my-2 text-center">
    <img src="assets/images/random_assets/warning.png" alt="warning icon" />
   
  </div>


<form [formGroup]="form" (ngSubmit)="onProceedClick()">
  <div class="my-3 text-center">
    <div class="card-sub-heading warning_title">Warning!</div>
    <div class="mt-2 bold px-4" style="color: #e3432a">
      To "Pay with other" option for OrderID: {{ props.item.OrderID }}, admin
      permission is required.
    </div>
  </div>
  <div class="d-flex justify-content-between border-bottom p-3">
    <div>Payment Due</div>
    <div><strong>${{ props.item.PaymentDue }}</strong></div>
  </div>
  <mat-checkbox
    class="example-margin bold mt-3 ml-3"
    (change)="onCheckChange($event)"
    formControlName="NotifyUsers"
  >
    Notify Users
  </mat-checkbox>
  <div class="row p-3" *ngIf="form.value.NotifyUsers">
    <div class="col-md-12">
      <div class="d-flex row pt-3">
        <ng-container formArrayName="NotifyUsersBy">
          <ng-container
            *ngFor="let item of notifyByArray.controls; let i = index"
          >
            <ng-container [formGroupName]="i">
              <div class="col-md-4">
                <mat-checkbox
                  value="{{ item.value.id }}"
                  formControlName="isChecked"
                  [disabled]="item.value.disable"
                  >{{ item.value.value }}
                </mat-checkbox>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <app-error-message
          [formName]="form"
          [fieldName]="'NotifyUsersBy'"
          [type]="'group'"
        >
        </app-error-message>
      </div>
    </div>
  </div>
  <div class="align-items-center mt-4 justify-content-center">
    <button class="custom-btn w-100 ml-0" type="submit">
      <!-- Proceed to Authenticate -->
      OK
      <span class="whiteLoader" *ngIf="isLoading">&nbsp;</span>
    </button>
    <button
      class="custom-btn mt-3 w-100 ml-0"
      (click)="dialogRef.close()"
      type="button"
    >
      Cancel
    </button>
  </div>
</form>
